import Component from '@glimmer/component';

export default class AppMyworldWatch extends Component {}
